import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import PlusSign from '@/images/PlusSign.svg';
import styled from '@emotion/styled';
import { Box, Typography, useTheme } from '@mui/material';
import { Photo } from 'react-photo-album/dist/types';

const ASPECT_RATIO = 16 / 9;

export const START_FROM_BLANK_TEMPLATE = {
    src: 'start-from-blank',
    width: 250,
    height: Math.round(250 / ASPECT_RATIO),
} satisfies Photo;

const BORDER_WIDTH = 1;

const BlankTemplateContainer = styled(Box)<{ $width: number }>`
    border: ${BORDER_WIDTH}px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.025);
    cursor: pointer;
    margin-bottom: 16px;
    width: ${({ $width }) => $width}px;
    height: ${({ $width }) => Math.round($width / ASPECT_RATIO)}px;
    &:hover {
        border-color: ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.colors.black[50]};
        box-shadow: 0px 1.32px 1.32px 0px rgba(0, 0, 0, 0.05);
    }
`;

const BlankTemplateText = styled(Typography)`
    color: ${({ theme }) => theme.colors.black[900]};
    font-weight: 600;
    font-size: 16px;
    line-height: 35.5px;
`;

type StartFromBlankProps = {
    onClick: () => void;
    width?: number;
};

export function StartFromBlank({ onClick, width = START_FROM_BLANK_TEMPLATE.width }: StartFromBlankProps) {
    const theme = useTheme();

    return (
        <BlankTemplateContainer onClick={onClick} $width={width - BORDER_WIDTH * 2} data-testid="templates-start-from-blank-button">
            <MaskedIcon src={PlusSign} color={theme.colors.secondary[900]} size="24px" />
            <BlankTemplateText variant="body1">Start from blank</BlankTemplateText>
        </BlankTemplateContainer>
    );
}
